<template>
  <view class="radio-group-column-num-demo">
    <view class="cube-radio-group-example">
      <cube-radio-group
        options="{{ options }}"
        colNum="{{ 3 }}"
        wx:model="{{ checkedValue }}"
        wx:model-prop="value"
      ></cube-radio-group>
    </view>
    <view class="view-desc">selected value: {{ checkedValue }}</view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    options: {
      styleIsolation: 'shared'
    },
    data: {
      options: [
        {
          value: 1,
          text: '1'
        },
        {
          value: 2,
          text: '2'
        },
        {
          value: 3,
          text: '3',
          disabled: true
        },
        {
          value: 4,
          text: '4'
        },
        {
          value: 5,
          text: '5'
        },
        {
          value: 6,
          text: '6'
        },
        {
          value: 7,
          text: '7'
        },
        {
          value: 8,
          text: '8'
        }
      ],
      checkedValue: ''
    }
  })
</script>

<style lang="stylus">
.radio-group-column-num-demo
  // TODO：CR 同理可抽到外层
  .cube-radio-group-example
    background-color #fff
    padding 5px 10px
  .desc
    margin-top 15px
</style>

<script type="application/json">
{
  "styleIsolation": "shared",
  "usingComponents": {
    "view-desc": "../../components/desc/index",
    "cube-radio-group": "@mpxjs/mpx-cube-ui/src/components/radio-group/index"
  }
}
</script>
